import { ReactNode } from 'react';

import styled from '@emotion/styled';

import COLOR from '../../../constant/colorset';
import { productCardImageWrapper } from '../../../styles/product-card-image-style';
import NextImage from '../../NextImage';
import { NoProductImageLogo } from '../../../images';

const Container = styled.div`
  ${productCardImageWrapper()};
  background-color: ${COLOR.kurlyGray150};
  > span > img {
    transition: all 0.5s ease-in-out;
  }
  :hover > span > img {
    transform: scale(1.02);
    transition: all 0.3s ease-in-out;
  }
`;

interface Props {
  imageUrl: string;
  children?: ReactNode;
  className?: string;
}

export default function ProductCardImage({ imageUrl, children, className }: Props) {
  return (
    <Container className={className}>
      <NextImage src={imageUrl ? imageUrl : NoProductImageLogo} layout="fill" objectFit="cover" alt="상품 이미지" />
      {children}
    </Container>
  );
}
